import { CurrentReservationType } from "../../../../../api/reservation";
import { useReservation } from "../../hooks/use-reservation";
import {
  ReservationOptionButtonWrapper,
  ReservationOptionItem,
  ReservationOptionItemWrapper,
  ReservationOptionWrapper,
} from "./style";

export interface ReservationOptionProps {
  onClose: () => void;
  hook: ReturnType<typeof useReservation>;
  setIsConfirmOpen: (v: boolean) => void;
}

const ReservationOptionModal = ({
  onClose,
  hook,
  setIsConfirmOpen,
}: ReservationOptionProps) => {
  const { type, setType, handleReservation } = hook;

  const handleConfirm = () => {
    if (type === CurrentReservationType.NORMAL) {
      handleReservation();
      onClose();
      return;
    }
    setIsConfirmOpen(true);
    onClose();
  };

  const reservationTypes = [
    { title: "일반 예약", type: CurrentReservationType.NORMAL },
    { title: "래빗 사용 예약", type: CurrentReservationType.SEED },
    { title: "이용권 사용 예약", type: CurrentReservationType.POINT },
  ];

  return (
    <ReservationOptionWrapper>
      <div className="title">예약 방식을 선택해주세요. </div>
      <ReservationOptionItemWrapper>
        {reservationTypes.map((item, index) => (
          <ReservationOptionItem
            isSelected={type === item.type}
            key={index}
            onClick={() => setType(item.type)}
          >
            {item.title}
          </ReservationOptionItem>
        ))}
      </ReservationOptionItemWrapper>
      <ReservationOptionButtonWrapper>
        <div className="button" onClick={onClose}>
          아니오
        </div>
        <div className="button purple" onClick={handleConfirm}>
          확인
        </div>
      </ReservationOptionButtonWrapper>
    </ReservationOptionWrapper>
  );
};

export default ReservationOptionModal;
